exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-36a04ae4]{color:#555;line-height:1.5rem;padding:10px}.btn[data-v-36a04ae4]{padding:0 30px}.tittle[data-v-36a04ae4]{box-shadow:0 0 5px #000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36a04ae4","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/myAgreement.vue
// module id = 96
// module chunks = 0